import React from "react";

/**
 * Ultra-minimal attribution mark — "Made by SSPL".
 *
 * Intentionally low-key: same `label-mono` family as the existing footer
 * eyebrow text, muted at 50% opacity so it sits below the build badge
 * and status dot in the visual hierarchy. On hover the link lifts to full
 * foreground so the user gets a soft cue that it's clickable, without
 * disturbing the surrounding chrome.
 *
 * Links to SovereignHPC's parent site (sovereignhpc.com.au). Opens in a
 * new tab with `rel="noopener noreferrer"` so we don't expose the VDR
 * window's `opener` reference to the destination.
 *
 * Props
 *   className   extra Tailwind classes appended to the anchor
 *   align       "left" | "center" | "right"   default: "center"
 */
export default function MadeBySSPL({ className = "", align = "center" }) {
  const justify =
    align === "left" ? "text-left"
    : align === "right" ? "text-right"
    : "text-center";
  return (
    <a
      data-testid="made-by-sspl"
      href="https://sovereignhpc.com.au"
      target="_blank"
      rel="noopener noreferrer"
      className={`label-mono text-muted-foreground/50 hover:text-foreground transition-colors select-none ${justify} ${className}`}
      title="SovereignHPC — sovereignhpc.com.au"
    >
      Made&nbsp;by&nbsp;SSPL
    </a>
  );
}
